import { Box, Button, Typography } from "@mui/material"
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded'
import { useParams, useNavigate } from 'react-router-dom'

const styles = {
    container: {
        color: 'primary.black',
        m: 0,
        p: 0,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Catamaran',
        backgroundColor: 'text.regular',
    },
    mainHeader: {
        fontWeight: 900,
        fontFamily: 'inherit',
        textAlign: 'center',
    },
    subHeader: {
        fontWeight: 450,
        fontFamily: 'inherit',
        textAlign: 'center',
        m: '.6rem 0',
        fontSize: '1.1rem',
    },
    button: {
        m: '1.4rem',
        p: '.8rem 1.2rem',
        fontFamily: 'inherit',
        color: 'text.regular',
        backgroundColor: 'primary.main',
        textTransform: 'none',
        boxShadow: "4px 5px 0px #000",
        borderRadius: "30px",
        fontWeight: 600,
    },
    buttonText: {
        fontSize: '1rem',
        textDecoration: 'none',
        color: 'text.regular',
    },
    footerHeader: {
        fontWeight: 900,
        fontFamily: 'inherit',
        textAlign: 'center',
        marginTop: '4rem',
        color: 'primary.main',
        cursor: 'pointer',
    },
}

export default function UserNotFoundView() {
    const navigate = useNavigate()
    const { username } = useParams()


    return (
        <Box sx={styles.container}>
            <Typography variant="h3" component="h3" sx={styles.mainHeader}>
                It's all yours
            </Typography>

            <Typography variant="body1" sx={styles.subHeader}>
                <pre><span style={{ color: '#354143' }}>vibio.co/</span>{username}</pre>
                is available for you to claim.
            </Typography>

            <Button
                type="submit"
                variant="contained"
                disableElevation
                sx={styles.button}
                onClick={() => window.open("https://vibio.co/login")}
                endIcon={<ArrowOutwardRoundedIcon />}
            >
                <span style={styles.buttonText}>
                    Sign Up & Claim
                </span>
            </Button>

            <Typography
                variant="h3"
                component="h5"
                onClick={() => navigate("/")}
                sx={styles.footerHeader}
            >
                Vibio
            </Typography>
            <Typography variant="caption">
                designed to tell your story
            </Typography>
        </Box>
    )
}
